import { useEffect, useState } from "react";
import { Header, Footer } from "@/components/Layout";
import { Loader2 } from "lucide-react";
import { getLegal } from "@/lib/api";
import { sanitizeHtml } from "@/lib/sanitize";

const fmt = (d) => {
  if (!d) return "";
  // Accept ISO datetime or YYYY-MM-DD
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return d;
  return dt.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
};

export const LegalPageView = ({ page, title }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getLegal(page)
      .then(setData)
      .catch(() => setData({ html: "", updated_at: "" }))
      .finally(() => setLoading(false));
  }, [page]);

  return (
    <div className="min-h-screen flex flex-col bg-sand">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto w-full px-6 sm:px-8 py-12 sm:py-16">
        <div className="text-center">
          <h1 className="font-heading text-3xl sm:text-4xl tracking-tight text-ink">{title}</h1>
          {data?.updated_at && (
            <p className="mt-2 text-sm text-ink-muted" data-testid="legal-updated">
              Last updated: {fmt(data.updated_at)}
            </p>
          )}
        </div>
        {loading ? (
          <div className="grid place-items-center py-20">
            <Loader2 className="h-7 w-7 animate-spin text-clay" />
          </div>
        ) : (
          <div
            className="article-prose mt-8 text-ink-soft"
            data-testid="legal-body"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(data?.html) }}
          />
        )}
      </main>
      <Footer />
    </div>
  );
};
